import * as React from 'react';
import { useErrorCollector } from '../../hooks';
import { FieldError } from '../Field';
import { jsx as _jsx } from "react/jsx-runtime";
export const ErrorCollector = props => {
  const {
    names
  } = props;
  const {
    errors
  } = useErrorCollector(names);
  const error = React.useMemo(() => {
    const errArr = Object.values(errors).reduce((r, e) => {
      return [...r, ...e];
    }, []);
    return Array.from(new Set(errArr)).join(',');
  }, [errors]);
  return /*#__PURE__*/_jsx(FieldError, {
    error: error
  });
};
//# sourceMappingURL=es/Other/ErrorCollector/index.js.map